// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // URL_SERVICE: 'http://localhost:8080/WSRestFec/API/WSRestAPI/', //Desarrollo
  
  // URL_SERVICE: 'https://tsafiliacionfec.ebsproductodigital.com/WSRestFec/API/WSRestAPI/', //Desarrollo
    // URL_SERVICE: 'https://tsafiliacionfecbe.ebsproductodigital.com/WSRestFecAut/API/WSRestAPI/', //ngDesarrollo AUTENTIC



   URL_SERVICE: 'https://fecafiliacionbe.ebscreditodigital.com/WSRestFec/API/WSRestAPI/', //PRODUCCION
  // URL_SERVICE: 'http://150.136.57.80:8081/WSRestFec/API/WSRestAPI/', //Desarrollo
  //URL_SERVICE: 'http://198.38.85.158:8081/WSRestFec/API/WSRestAPI/',//Pruebas
  // URL_SERVICE: 'https://ebsappweb.com:8443/WSRestFec/API/WSRestAPI/', // Produccion

};

/*
// ng build --output-hashing=all --prod --base-href /
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
